/**
 * @generated SignedSource<<1692ddbb13caf9bf689e0e6a7b83278d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type boardFilterRefinement_softwareBoard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Filter">;
  readonly " $fragmentType": "boardFilterRefinement_softwareBoard";
};
export type boardFilterRefinement_softwareBoard$key = {
  readonly " $data"?: boardFilterRefinement_softwareBoard$data;
  readonly " $fragmentSpreads": FragmentRefs<"boardFilterRefinement_softwareBoard">;
};

import boardFilterRefinementRefetchQuery_graphql from './boardFilterRefinementRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": boardFilterRefinementRefetchQuery_graphql
    }
  },
  "name": "boardFilterRefinement_softwareBoard",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Filter"
    }
  ],
  "type": "Query"
};

(node as any).hash = "3b2a53086fd06a72f2c1fdda400eab92";

export default node;
